import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "@/firebase/firebase";
import { E2E_AUTH_REFUSAL_MESSAGE, isAllowedE2EHost } from "./e2eAuthSafety";

const getFirebaseConfigDetails = () => {
  const { projectId, authDomain } = auth.app.options || {};
  return `frontend projectId=${projectId || "missing"}, authDomain=${authDomain || "missing"}`;
};

const getFirebaseAuthErrorMessage = (error) => {
  const code = error?.code || "unknown";
  const message = error?.message || "Unknown Firebase auth error.";
  const configDetails = getFirebaseConfigDetails();

  if (code === "auth/invalid-custom-token" || code === "auth/custom-token-mismatch") {
    return `E2E Firebase auth failed: code=${code}; message=${message}; ${configDetails}. Check that the DEV backend Firebase Admin service account and frontend Firebase config use the same Firebase project.`;
  }

  return `E2E Firebase auth failed: code=${code}; message=${message}; ${configDetails}.`;
};

const E2EAuthPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Signing in E2E user...");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const run = async () => {
      if (!isAllowedE2EHost(window.location.hostname)) {
        setErrorMessage(E2E_AUTH_REFUSAL_MESSAGE);
        return;
      }

      const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      const token = params.get("token");
      const redirect = params.get("redirect") || "/uploads";

      if (!token) {
        setErrorMessage("Missing Firebase custom token for E2E auth.");
        return;
      }

      try {
        setStatus(`Signing in E2E user with ${getFirebaseConfigDetails()}...`);
        await signInWithCustomToken(auth, token);
        navigate(redirect.startsWith("/") ? redirect : "/uploads", { replace: true });
      } catch (error) {
        setErrorMessage(getFirebaseAuthErrorMessage(error));
      }
    };

    run();
  }, [navigate]);

  return (
    <main style={{ padding: 24 }}>
      <p role="status" data-testid="e2e-auth-status">
        {status}
      </p>
      {errorMessage && (
        <p role="alert" data-testid="e2e-auth-error">
          {errorMessage}
        </p>
      )}
    </main>
  );
};

export default E2EAuthPage;
